import "./polyfills";

import './frc-loader'
import Vue from 'vue'
import Flow from './App.vue'
import router from './router'
import i18n from "./lang/lang";
import Notify from './plugins/notify/notify'
import FlowHelper from './plugins/flow-helper/flow-helper'
import DhHelper from './plugins/dh-helper/dh-helper'
import MiHelper from './plugins/mi-helper/mi-helper'

Vue.config.productionTip = false;
// Vue.prototype.$appBasePath = "http://flowview.partheas.net";
// Vue.prototype.$appBasePath = "http://10.128.8.234:8080";
// Vue.prototype.$appBasePath = "http://10.128.8.233:8080";
// Vue.prototype.$appBasePath = "http://localhost:8080";
Vue.prototype.$appBasePath = "https://flow.mediport.partheas.net";

router.beforeEach(function (to, from, next) {
    let frc = Vue.prototype.$frc;

    if (to.path === "/auth_callback") {
        const query = to.query;
        frc.clearTokenCookies();
        if (query.hasOwnProperty("token")) {
            var result = frc.setToken(query["token"]);
            if (!result) {
                console.log("Failed to get the token");
            } else {
                next("/dashboard")
            }
        } else {
            window.location = "http://locahost:9999/api/info";
        }
    } else if (to.path !== "/logout") {
        frc.verifyAccess().then(function (res) {
            if (to.path === "/account_setup") {
                next();
            } else if (!Vue.prototype.$currentUser) {
                frc.getCurrentUser().then(function (res) {
                    let overview = res.data.overview;
                    let user = overview.user;
                    let physicians;

                    if (user && user.userAgendaPhysicians && (user.userAgendaPhysicians instanceof Array)) {
                        physicians = user.userAgendaPhysicians;
                    } else {
                        physicians = [];
                    }

                    user.physicians = physicians;
                    overview.user = user;
                    Vue.prototype.$currentUser = overview;
                    Vue.prototype.$isAccountComplete = res.data.isAccountComplete;
                    if (Vue.prototype.$currentUser.user.language) {
                        Vue.setLocale(Vue.prototype.$currentUser.user.language);
                    }

                    if (Vue.prototype.$isAccountComplete === false) {
                        window.location = Vue.prototype.$appBasePath + "/account_setup";
                        return;
                    }

                    validateRoleAndWard(to, next);

                }).catch(function (res) {
                    console.log(res);
                    Vue.notifyError({title: "Something bad happened. Contact Admin"});
                    alert("You'll be logged out now");
                    next("/logout");
                });
            } else {
                if (Vue.prototype.$isAccountComplete === false) {
                    window.location = Vue.prototype.$appBasePath + "/account_setup";
                    return;
                }
                next();
            }
        }).catch(function (res) {
            const path = Vue.prototype.$frc.getJWTWithKeycloakLoginPath(Vue.prototype.$appBasePath + "/auth_callback");
            window.location = path;
        });
    } else if (to.path === '/logout') {
        frc.clearTokenCookies();
        localStorage.clear();
        next();
    } else {
        next();
    }
});

function validateRoleAndWard(to, next) {
    var metaRole = "to.meta." + Vue.prototype.$currentUser.user.role;
    var dhMenuItem = eval("to.meta.dh");
    var hideInNonDh = eval("to.meta.hideInNonDh");

    if (!eval(metaRole)) {
        next("/problem?reason=access");
    } else {
        next();
    }

    if (!validateAndSetWard()) {
        next("/problem?reason=ward");
    } else {
        next();
    }

    if (Vue.prototype.$showStatusOverviewMenu) {
        if (!dhMenuItem) {
            next("/dashboard");
        } else {
            next();
        }
    } else {
        if (hideInNonDh) {
            next("/dashboard");
        } else {
            next();
        }
    }
}

function validateAndSetWard() {
    // First, get all the wards of the current user.
    // If there are no wards linked for this user. Then the user should not be give access.
    var allWards = Vue.prototype.$currentUser.lwWards;
    if (!allWards || allWards.length < 1) {
        return false;
    }

    // Next, get the current-ward id cookie value
    var wardId = Vue.getCurrentWardIdCookie();
    if (!wardId) {
        // If the cookie is not set, the set it now
        Vue.setCurrentWard(allWards[0]);

        return true;
    }

    // Okay, there is a ward id in the cookie. Let's see if it's a valid ward id.
    // A valid ward id is something which exists in the linked wards of the current user
    for (var i in allWards) {
        if (allWards[i].id === wardId) {
            // We matched a ward! Let's update the cookie and global Vue config
            Vue.setCurrentWard(allWards[i]);

            return true;

        }
    }

    // Nothing has matched. So, let's set the first ward
    Vue.setCurrentWard(allWards[0]);

    return true;
}

Vue.use(Notify);
Vue.use(FlowHelper);
Vue.use(DhHelper);
Vue.use(MiHelper);

export const EventBus = new Vue();

new Vue({
    router,
    i18n,
    render: h => h(Flow),
    el: '#app'
});
